<template>
  <div class="contact-page">
    <van-nav-bar
      :title="title"
      left-text=""
      left-arrow
      @click-left="onClickLeft"
    />
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="init"
      >
        <div class="contact-body">
          <div v-for="(item, index) in userList" :key="index">
            <div class="cell-card active-card" @click="selectContact(item)">
              <div class="cell-edit" v-on:click.stop="editContact(item)">
                编辑
              </div>
              <div>姓名：{{ item.name }}</div>
              <div>手机号：{{ item.mobile }}</div>
              <div>证件类型：{{ item.certTypeValue }}</div>
              <div>证件号：{{ item.idCard }}</div>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <div class="footer">
      <div class="footer-button" @click="addContact">新增{{ title }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "alwaysContact",
  data() {
    return {
      userList: [],
      user: undefined,
      title: "常用联系人",
      loading: false,
      finished: false,
      refreshing: false,
      pageNum: 1,
    };
  },
  mounted() {
    if (this.$route.query.isTourist && this.$route.query.isTourist == "1") {
      this.title = "常用旅客";
    }
    // this.init();
  },
  methods: {
    init() {
      this.$API.user
        .getModeList({
          pageSize: 10,
          pageNum: this.pageNum,
          isTourist: this.$route.query.isTourist || "0",
        })
        .then((res) => {
          this.finished = false;
          if (this.pageNum == 1) {
            this.userList = res.data.frequentContact;
          } else {
            this.userList = this.userList.concat(res.data.frequentContact);
          }
          if (res.data.frequentContact.length < 10) {
            this.finished = true;
          }
          this.pageNum = this.pageNum + 1;
          this.refreshing = false;
          this.loading = false;
        })
        .catch((err) => {});
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.pageNum = 1;
      this.init();
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    onClickRight() {},
    editContact(item) {
      this.$router.push({
        path: "/order/add-contact",
        query: { info: { ...item } },
      });
    },
    selectContact(item) {
      this.user = item;
      this.$router.back();
    },
    addContact() {
      this.$router.push({
        path: "/order/add-contact",
        query: { isTourist: this.$route.query.isTourist || "0" },
      });
    },
  },

  //即将离开时
  beforeRouteLeave(to, from, next) {
    if (this.user) {
      to.params.user = this.user;
    }
    next();
  },
};
</script>

<style lang="scss" scoped>
.contact-page {
  height: 100%;
  background-color: #f4f6f9;
  .contact-body {
    margin: vw(24) vw(30) vw(120);
    display: flex;
    flex-direction: column;
    .cell-card {
      position: relative;
      padding: vw(15) vw(40);
      margin-top: vw(20);
      background-color: white;
      border-radius: 5px;
      > div {
        padding: vw(15) 0;
        font-size: vw(28);
        color: #333;
      }
      .cell-edit {
        position: absolute;
        right: 15px;
        color: $theme-color;
        font-size: vw(26);
      }
    }
    .active-card {
      border: 1px solid $theme-color;
    }
  }

  .footer {
    background-color: #f4f6f9;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0 vw(30) vw(60);
    .footer-button {
      border-radius: 5px;
      border: 1px solid $theme-color;
      text-align: center;
      height: vw(70);
      line-height: vw(70);
      color: $theme-color;
      font-size: vw(30);
    }
  }
}
</style>
